import React from 'react';
import { Link } from 'react-router-dom';

const GetStarted = () => {
  return (
    <div className="simple-page">
      <div className="simple-card">
        <h1>Get Started</h1>
        <p>教程页面即将上线。</p>
        <Link to="/" className="primary-btn">Back to Home</Link>
      </div>
    </div>
  );
};

export default GetStarted;
